<delivery-conditions
    [editable]="editable"
    [condition]="condition"
    (onCreate)="update($event.value)"
    (onUpdate)="update($event.value)"
    (onDelete)="deleteCurrent()"
></delivery-conditions>
